import { useQueryApi } from "api/hooks.ts";
import { roleApi } from "api/TenantSlug/Role/api.ts";

import GetRoleResponse = App.Http.Responses.Role.GetRoleResponse;
import GetRolesResponse = App.Http.Responses.Role.GetRolesResponse;
import GetRoleRequest = App.Http.Requests.Role.GetRoleRequest;
import GetRolesRequest = App.Http.Requests.Role.GetRolesRequest;

export const useGetRolesQuery = (request: GetRolesRequest, options = {}) => {
    return useQueryApi<GetRolesResponse>({
        queryKey: ["getRoles", request],
        queryFn: () => roleApi.index(request),
        ...options,
    });
};

export const useGetRoleQuery = (key: string, request: GetRoleRequest, options = {}) => {
    return useQueryApi<GetRoleResponse>({
        queryKey: ["getRole", key, request],
        queryFn: () => roleApi.show(key, request),
        ...options,
    });
};
